"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require("./BaseClass");

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Payment = function (_BaseClass) {
  _inherits(Payment, _BaseClass);

  /**
   * Id der Zahlweise
   * @type {string}
   */

  /**
   * Bankname
   * @type {string}
   */

  /**
   * Iban
   * @type {string}
   */

  /**
   * Bic
   * @type {string}
   */

  /**
   * Inhaber des Bankkontos
   * @type {string}
   */

  /**
   * Ist des die Standartzahlweise?
   * @type {boolean}
   */

  /**
   * Art der Zahlweise
   * @type {string}
   */

  /**
   * Kennnummer der Art der Zahlweise
   * @type {integer}
   */

  /**
   * Gültig von
   * @type {date}
   */
  function Payment() {
    _classCallCheck(this, Payment);

    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this));

    _this.Id = "";
    _this.BankName = "";
    _this.Iban = "";
    _this.Bic = "";
    _this.AccountOwner = "";
    _this.IsDefaultPaymentMethod = true;
    _this.PaymentMethod = "";
    _this.PaymentMethodValue = 0;
    _this.ValidFrom = "";
    _this.ValidTo = "";
    return _this;
  }
  /**
   * Gültig bis
   * @type {date}
   */


  return Payment;
}(_BaseClass3.default);

exports.default = Payment;